import axios from "axios";
import WebApp from "@twa-dev/sdk";
import { API_URL } from "../config";

const options = APIKey => ({ params: { initData: WebApp.initData }, headers: { "x-api-key": APIKey } });
const key = userId => `purchase-submissions:${userId}`;
function submissions(userId) {
  try { return JSON.parse(localStorage.getItem(key(userId)) || '{}'); } catch { return {}; }
}
function clearSubmission(userId, orderId) {
  try {
    const stored = submissions(userId); delete stored[orderId];
    localStorage.setItem(key(userId), JSON.stringify(stored));
  } catch { /* A completed server order remains authoritative. */ }
}
export async function retryPurchase(orderId, userId, APIKey) {
  const boc = submissions(userId)[orderId];
  const path = boc ? 'submit-ton' : 'retry';
  const { data } = await axios.post(`${API_URL}/api/purchases/${orderId}/${path}`, boc ? { boc } : {}, options(APIKey));
  if (['fulfilled', 'refunded'].includes(data.state)) {
    clearSubmission(userId, orderId);
  }
  return data;
}
export async function waitForPurchase(orderId, APIKey, attempts = 10) {
  let latest;
  for (let i = 0; i < attempts; i++) {
    const { data } = await axios.get(`${API_URL}/api/purchases/${orderId}`, options(APIKey));
    latest = data;
    if (['fulfilled', 'refunded', 'review'].includes(data.state)) return data;
    await new Promise(resolve => setTimeout(resolve, 2000));
  }
  return latest;
}
export async function buyWithTon(selection, userId, APIKey, tonConnectUI) {
  const { data: order } = await axios.post(`${API_URL}/api/purchases`, { ...selection, method: 'ton' }, options(APIKey));
  const result = await tonConnectUI.sendTransaction(order.transaction);
  // Save before the HTTP request so a network failure or reload can resume safely.
  const stored = submissions(userId); stored[order.orderId] = result.boc;
  try { localStorage.setItem(key(userId), JSON.stringify(stored)); } catch { /* Server submission still takes priority. */ }
  try {
    // Submit directly even when browser storage is unavailable.
    const { data: submitted } = await axios.post(`${API_URL}/api/purchases/${order.orderId}/submit-ton`, { boc: result.boc }, options(APIKey));
    if (submitted.state === 'fulfilled') { clearSubmission(userId, order.orderId); return submitted; }
    const completed = await waitForPurchase(order.orderId, APIKey);
    if (completed.state === 'fulfilled') clearSubmission(userId, order.orderId);
    return completed;
  } catch {
    return { ...order, state: 'verifying', error: 'Payment submitted. Resume it in Profile → Purchases. Do not pay again.' };
  }
}
export async function listPurchases(APIKey) {
  return (await axios.get(`${API_URL}/api/purchases`, options(APIKey))).data;
}
